// analytics.js
// Small wrapper around gtag that checks consent first.
import { loadConsent } from './cookieConsent';

function hasAnalyticsConsent() {
  const c = loadConsent();
  return c && c.analytics === true;
}

/**
 * Send a page_view to GA4 if analytics consent is given and gtag is available.
 * @param {string} path
 */
export function sendPageView(path) {
  if (!hasAnalyticsConsent()) return;
  if (typeof window === 'undefined' || !window.gtag) return;
  try {
    // GA4 expects a page_view event or config call. Use event for explicit tracking.
    window.gtag('event', 'page_view', {
      page_path: path,
    });
  } catch (e) {
    // ignore
  }
}

/**
 * Send a custom event to GA (if consent given).
 * @param {string} name
 * @param {object} params
 */
export function sendEvent(name, params = {}) {
  if (!hasAnalyticsConsent()) return;
  if (typeof window === 'undefined' || !window.gtag) return;
  try {
    window.gtag('event', name, params);
  } catch (e) {
    // ignore
  }
}

export default {
  sendPageView,
  sendEvent,
};
